<template>
    <div class="banner">
        <div class="content">
            <div class='content-l'>
                <svg
                    class="icon-security-2"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    fill="none"
                    version="1.1"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"><g><g><path d="M12,21.5C17.2467,21.5,21.5,17.2467,21.5,12C21.5,6.75329,17.2467,2.5,12,2.5C6.75329,2.5,2.5,6.75329,2.5,12C2.5,17.2467,6.75329,21.5,12,21.5ZM13,14L13,7L11,7L11,14L13,14ZM13,18L13,16L11,16L11,18L13,18Z"
                        fill-rule="evenodd"
                        fill="#FAAA32"
                        fill-opacity="1"/></g></g></svg>
                <div class='content-mobile'>
                    <span v-html="text"></span>
                    <button class='totp-open' @click='btnFunc' v-if='showBtns'>{{btnText}}</button>
                </div>
            </div>

            <span class='content-r icon-icon-error-3' @click='closeFunc'></span>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { config } from 'CONFIG';

export default Vue.extend({
    props: {
        text: String,
        btnText: String,
        showBtns: {
            type: Boolean,
            default: true
        },
        gaLabel: String
    },
    data () {

        return {
            config
        };

    },
    computed: {

    },
    methods: {
        btnFunc () {

            this.$emit( 'btnClick' );

        },
        closeFunc () {

            this.$emit( 'closeClick' );

        }
    }

});
</script>

<style lang="less" scoped>
.banner{
    z-index: 8;
    font-size: .18rem;
    line-height: 1.4;
    width: 100%;
    background-color: #FFECDB;
    color: #333333;
    height: 56px;
    display: flex;
    align-items: center;
    @media @snapeak_mobile{
        height: auto;
        padding: 8px 16px;
        box-sizing: border-box;
    }
    .content{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1032px;
        margin:0 auto;
        @media @snapeak_mobile{
            width: 100%;
        }
        .content-l{
            display: flex;
            align-items:center;
            @media @snapeak_mobile{
                flex: 1;
                margin-right: 10px;
            }
            .icon-security-2{
                width: 24px;
                height: 24px;
                path{
                    fill: @warning;
                }
                margin-right:8px;
                display: inline-block;
            }
            .content-mobile{
                display: flex;
                align-items: center;
                @media @snapeak_mobile{
                    flex: 1;
                }
                span{
                    font-family: @font_02;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 22px;
                    letter-spacing: 0em;
                    color: #3D3D3D;
                }
            }
        }
        .content-r{
            font-size: 13px;
            cursor: pointer;
            @media @snapeak_mobile{
                font-size: 9px;
            }
        }
        .totp-open{
            box-sizing:border-box;
            background: transparent;
            border: none;
            color: #FF7B00;
            text-align: center;
            font-family: @font_02;
            font-size: 14px;
            font-weight: 600;
            line-height: 22px;
            letter-spacing: 0em;
            padding: 0;
            display: inline-block;
            cursor: pointer;
            margin-left: 8px;
            flex-shrink: 0;
            @media @snapeak_mobile{
                margin-right: 12px;
                margin-left: 0;
            }
        }
    }
}

</style>
